export const BarChart = {
  url: '/images/emojis/BarChart.webp',
  alt: 'Emoji Graphique avec barres verticale'
};

export const Books = {
  url: '/images/emojis/Books.webp',
  alt: 'Emoji Pile de livres'
};

export const BookmarkTabs = {
  url: '/images/emojis/BookmarkTabs.webp',
  alt: 'Emoji Marque-page'
};

export const BriefCase = {
  url: '/images/emojis/BriefCase.webp',
  alt: 'Emoji Malette'
};

export const CardIndex = {
  url: '/images/emojis/CardIndex.webp',
  alt: 'Emoji Annuaire Cartes de visites'
};

export const CardIndexDividers = {
  url: '/images/emojis/CardIndexDivider.webp',
  alt: 'Emoji Intercalaires'
};

export const ChartIncreasing = {
  url: '/images/emojis/ChartIncreasing.webp',
  alt: 'Emoji Graphique croissant'
};

export const CheckBoxWithCheck = {
  url: '/images/emojis/CheckBoxWithCheck.webp',
  alt: 'Emoji Checkbox validée'
};

export const Crayon = {
  url: '/images/emojis/Pen.webp',
  alt: 'Emoji Crayon'
};

export const CreditCard = {
  url: '/images/emojis/CreditCard.webp',
  alt: 'Emoji Carte bleu'
};

export const CrossMark = {
  url: '/images/emojis/CrossMark.webp',
  alt: 'Emoji Marque rouge'
};

export const CrystalBall = {
  url: '/images/emojis/CrystalBall.webp',
  alt: 'Emoji Boule de cristal'
};

export const Factory = {
  url: '/images/emojis/Factory.webp',
  alt: 'Emoji Usine'
};

export const FaxMachine = {
  url: '/images/emojis/FaxMachine.webp',
  alt: 'Emoji Machine de fax'
};

export const Fire = {
  url: '/images/emojis/Fire.webp',
  alt: 'Emoji Flamme'
};

export const FlexedBiceps = {
  url: '/images/emojis/FlexedBiceps.webp',
  alt: 'Emoji Biceps fléchis'
};

export const GradutationCap = {
  url: '/images/emojis/GraduationCap.webp',
  alt: 'Emoji Chapeau de graduation'
};

export const Hammer = {
  url: '/images/emojis/Hammer.webp',
  alt: 'Emoji Marteau et clé'
};

export const Handshake = {
  url: '/images/emojis/Handshake.webp',
  alt: 'Emoji Poignée de main'
};

export const JackOLantern = {
  url: '/images/emojis/JackOLantern.webp',
  alt: 'Emoji Citrouille'
};

export const Key = {
  url: '/images/emojis/Key.webp',
  alt: 'Emoji Clé'
};

export const Label = {
  url: '/images/emojis/Label.webp',
  alt: 'Emoji Etiquette'
};

export const LightBulb = {
  url: '/images/emojis/LightBulb.webp',
  alt: 'Emoji Ampoule'
};

export const Locked = {
  url: '/images/emojis/Locked.webp',
  alt: 'Emoji Cadenas'
};

export const Memo = {
  url: '/images/emojis/Memo.webp',
  alt: 'Emoji Bloc-notes'
};

export const NerdFace = {
  url: '/images/emojis/NerdFace.webp',
  alt: 'Emoji Visage avec lunettes'
};

export const OpenFileFolder = {
  url: '/images/emojis/OpenFileFolder.webp',
  alt: 'Emoji Dossier ouvert'
};

export const Package = {
  url: '/images/emojis/Package.webp',
  alt: 'Emoji Carton de colis'
};

export const PageWithCurl = {
  url: '/images/emojis/PageWithCurl.webp',
  alt: 'Emoji Page pliée'
};

export const PostBox = {
  url: '/images/emojis/PostBox.webp',
  alt: 'Emoji Boite aux lettres'
};

export const ShoppingBags = {
  url: '/images/emojis/ShoppingBags.webp',
  alt: 'Emoji Sacs de supermarché'
};

export const ShoppingCart = {
  url: '/images/emojis/ShoppingCart.webp',
  alt: 'Emoji Caddie de supermarché'
};

export const SmilingFaceWithSmilingEyes = {
  url: '/images/emojis/SmilingFaceWithSmilingEyes.webp',
  alt: 'Emoji Tête souriant'
};

export const SmilingFaceWithSunglasses = {
  url: '/images/emojis/SmilingFaceWithSunglasses.webp',
  alt: 'Emoji Tête souriant avec des lunettes de soleil'
};

export const SportsMedal = {
  url: '/images/emojis/SportMedal.webp',
  alt: 'Emoji Médaille'
};

export const WavingHand = {
  url: '/images/emojis/WavingHand.webp',
  alt: 'Emoji Main'
};

export const FlagInHole = {
  url: '/images/emojis/FlagInHole.webp',
  alt: 'Emoji drapeau'
};

export const Shield = {
  url: '/images/emojis/Shield.webp',
  alt: 'Bouclier'
};

export const FaceMonocle = {
  url: '/images/emojis/FaceMonocle.webp',
  alt: 'Visage avec un monocle'
};

export const NewButton = {
  url: '/images/emojis/NewButton.webp',
  alt: 'Bouton nouveauté'
};

export const RevieledFace = {
  url: '/images/emojis/RevieledFace.webp',
  alt: 'Emoji confort'
};

export const MoneyBag = {
  url: '/images/emojis/MoneyBag.webp',
  alt: "Sac d'argent"
};

export const HaloFace = {
  url: '/images/emojis/HaloFace.webp',
  alt: 'Emoji visage avec Halo'
};

export const Tree = {
  url: '/images/emojis/Tree.webp',
  alt: 'Emoji arbre'
};

export const RedHeart = {
  url: '/images/emojis/RedHeart.webp',
  alt: 'Coeur rouge'
};

export const Link = {
  url: '/images/emojis/Link.webp',
  alt: 'Lien'
};

export const Globe = {
  url: '/images/emojis/globe.webp',
  alt: 'Globe'
};

export const Gift = {
  url: '/images/emojis/Gift.webp',
  alt: 'Cadeau'
};

export const Ruler = {
  url: '/images/emojis/Ruler.webp',
  alt: 'Equerre'
};

export const PalmsUpTogether = {
  url: '/images/emojis/PalmsUpTogether.webp',
  alt: 'Don avec les mains'
};

export const Teacher = {
  url: '/images/emojis/Teacher.webp',
  alt: 'Prof'
};

export const Calendar = {
  url: '/images/emojis/Calendar.webp',
  alt: 'Calendrier'
};

export const Hourglass = {
  url: '/images/emojis/Hourglass.webp',
  alt: 'Sablier'
};

export const PoliceLight = {
  url: '/images/emojis/PoliceLight.webp',
  alt: 'Gyrophare'
};

export default {
  Calendar,
  Hourglass,
  PoliceLight,
  RedHeart,
  Tree,
  HaloFace,
  MoneyBag,
  RevieledFace,
  NewButton,
  Shield,
  FaceMonocle,
  BarChart,
  Books,
  BookmarkTabs,
  BriefCase,
  CardIndex,
  CardIndexDividers,
  ChartIncreasing,
  CheckBoxWithCheck,
  Crayon,
  CreditCard,
  CrossMark,
  CrystalBall,
  Factory,
  FaxMachine,
  Fire,
  FlexedBiceps,
  GradutationCap,
  Hammer,
  Handshake,
  Key,
  JackOLantern,
  Label,
  LightBulb,
  Locked,
  Memo,
  NerdFace,
  OpenFileFolder,
  Package,
  PageWithCurl,
  PostBox,
  ShoppingBags,
  ShoppingCart,
  SmilingFaceWithSmilingEyes,
  SmilingFaceWithSunglasses,
  SportsMedal,
  WavingHand,
  FlagInHole,
  Link,
  Globe,
  Gift,
  Ruler,
  PalmsUpTogether,
  Teacher
};
